import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import Config from './Config';
import { getAccessToken } from './utils/token';

const apiUrl = Config.apiUrl;
const token = getAccessToken();
const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
const useApiBackend = !isDev && !!token; // 운영 환경이며 토큰이 있을 때만 API 경로 사용

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    backend: {
      // HttpBackend는 문자열 템플릿만 지원하므로 Promise를 반환하지 않도록 고정 경로 사용
      loadPath: useApiBackend
        ? `${apiUrl}/console/i18n/{{lng}}/{{ns}}.json`
        : `/locales/{{lng}}/{{ns}}.json`,
      requestOptions: useApiBackend
        ? {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        : undefined,
    },
    lng: 'ko',
    fallbackLng: 'ko',
    ns: ['console'],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;